export const icons = {
    'splash': require('../../assets/img/splash.png'),
    'left_arrow': require('../../assets/img/left_arrow.png'),
    'dropdown': require('../../assets/img/dropdown.png'),
    'ad_logo': require('../../assets/img/ad_logo.png'),
    'add_person': require('../../assets/img/add_person.png'),
    'keypass': require('../../assets/img/keypass.png'),
    'messagephone': require('../../assets/img/messagephone.png'),
    'notifiction': require('../../assets/img/notifiction.png'),
    'menu': require('../../assets/img/menu.png'),
    'temp_slider': require('../../assets/img/temp_slider.png'),
    'ad_salamat': require('../../assets/img/ad_salamat.png'),
    'ad_hamkar': require('../../assets/img/ad_hamkar.png'),
    'right_arrow': require('../../assets/img/right_arrow.png'),
    'ad': require('../../assets/img/ad.png'),
    'wallet': require('../../assets/img/wallet.png'),
    'support': require('../../assets/img/support.png'),
    'star': require('../../assets/img/star.png'),
    'setting': require('../../assets/img/setting.png'),
    'requests': require('../../assets/img/requests.png'),
    'pinmap': require('../../assets/img/pinmap.png'),
    'pin': require('../../assets/img/pin.png'),
    'logout': require('../../assets/img/logout.png'),
    'emailbox': require('../../assets/img/emailbox.png'),
    'diamond': require('../../assets/img/diamond.png'),
    'avatar': require('../../assets/img/avatar.png'),
    'back': require('../../assets/img/back.png'),
    'plus': require('../../assets/img/plus.png'),
    'address_pin': require('../../assets/img/pinaddress.png'),
    'temp_zakhm': require('../../assets/img/temp_zakhm.png'),
    'invoice': require('../../assets/img/invoice.png'),
    'remove_account': require('../../assets/img/remove_account.png'),
    'add': require('../../assets/img/add.png'),
    'onmappin': require('../../assets/img/onmappin.png'),
    'edit': require('../../assets/img/edit.png'),
    'remove': require('../../assets/img/remove.png'),
    'more': require('../../assets/img/more.png'),
    'camera': require('../../assets/img/camera.png'),
    'karkard': require('../../assets/img/karkard.png'),
    'video': require('../../assets/img/video.png'),
    'call': require('../../assets/img/call.png'),
    'arrived': require('../../assets/img/arrived.png'),
    'cancel': require('../../assets/img/cancel.png'),
    'finish': require('../../assets/img/finish.png'),
    'target': require('../../assets/img/target.png'),
    'mypin': require('../../assets/img/mypin.png'),
    'route': require('../../assets/img/route.png'),
    'law': require('../../assets/img/law.png'),
    'splash_top': require('../../assets/img/splash_top.png'),
    'splash_bottom': require('../../assets/img/splash_bottom.png'),


}
